import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import {
  getDefaultCountryCode,
  getOperatingCountryCodes,
  getClubList
} from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { asyncValidateEmailNotArray } from 'redux/customer/helpers';

import Email from './components/Email';
import GiftMessage from './components/GiftMessage';
import ShippingInstructions from './components/ShippingInstructions';
import { validateForNotLoggedInCustomerShip } from './validators';

class Customer extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const clubSignup = {
      email: data.email,
      isSubscribe: data.isSubscribe,
      shipTo: data,
      orderDeliveryMethod: 'Ship',
      giftMessage: data.giftMessage,
      shippingInstructions: data.shippingInstructions
    };
    delete clubSignup.shipTo.email;
    delete clubSignup.shipTo.isSubscribe;
    delete clubSignup.shipTo.giftMessage;
    delete clubSignup.shipTo.shippingInstructions;
    const successFunction = () => {
      props.onEdit('payment');
    };
    props.updateClubSignup(clubSignup, successFunction);
  };

  handlePickup = (e) => {
    e.preventDefault();
    const { onPickup } = this.props;
    onPickup();
  };

  render() {
    const { change, handleSubmit, form, settings, clubSignup } = this.props;
    const object = { countryCode: getDefaultCountryCode(settings) };
    let clubSelection = 'club selection';
    if (isPreSale()) {
      clubSelection = 'pre-sale selection';
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <Email />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Shipping address</h3>
          <a
            className="c7-checkout__content__title__pickup"
            onClick={this.handlePickup}
          >
            I prefer to pick up my club shipment
          </a>
        </div>
        <AddressForm
          object={object}
          changeFunction={change}
          type="Operating"
          settings={settings}
        />
        <GiftMessage clubSignup={clubSignup} />
        <ShippingInstructions clubSignup={clubSignup} />

        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to payment information
          </button>
          <a href={`${getClubList(settings)}`}>Return to {clubSelection}</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = transformAddressData(values);
  data.email = values.email;
  data.isSubscribe = values.isSubscribe || false;
  if (values.isGiftMessage) {
    data.giftMessage = values.giftMessage;
  } else {
    data.giftMessage = null;
  }
  if (values.isShippingInstructions) {
    data.shippingInstructions = values.shippingInstructions;
  } else {
    data.shippingInstructions = null;
  }
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateForNotLoggedInCustomerShip(data, ownProps.settings);
  return errors;
};

const mapStateToProps = (state) => {
  const clubSignup = state.clubSignup.data;
  let initialValues = {};
  if (clubSignup) {
    const { shipTo } = clubSignup;
    initialValues = initialFormValues(shipTo);
    initialValues.email = clubSignup.email;
    initialValues.isSubscribe = clubSignup.isSubscribe;
    initialValues.giftMessage = clubSignup.giftMessage;
    initialValues.isGiftMessage = !!clubSignup.giftMessage;
    initialValues.shippingInstructions = clubSignup.shippingInstructions;
    initialValues.isShippingInstructions = !!clubSignup.shippingInstructions;
  }
  if (
    !initialValues.countryCode ||
    getOperatingCountryCodes(state.setting).length === 1
  ) {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    initialValues,
    settings: state.setting
  };
};

const asyncValidate = (values) => {
  const { email } = values;
  if (email) {
    return asyncValidateEmailNotArray(email).then((errors) => {
      if (errors) {
        throw errors;
      }
    });
  }
  return Promise.resolve(null);
};

Customer = reduxForm({
  form: 'customerNotLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate,
  asyncValidate,
  asyncBlurFields: ['zipCode', 'email']
})(Customer);

export default connect(mapStateToProps, { updateClubSignup })(Customer);
